import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';
import { PmtBootstrapModule } from '@premotec/pmt-bootstrap';
import { PmtDatepickerModule } from '@premotec/pmt-datepicker';
import { PmtEssentialsModule } from '@premotec/pmt-essentials';
import { PmtPushNotificationsModule } from '@premotec/pmt-push-notifications';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgPipesModule } from 'ngx-pipes';
import { ToastrModule } from 'ngx-toastr';

import { AssignmentSchedulesListComponent } from '../assignments/assignment-schedules/components/assignment-schedules-list/assignment-schedules-list.component';
import { AssignmentListComponent } from '../assignments/components/assignments-list/assignments-list.component';
import { DocumentLinkDisplayModalComponent } from '../document-links/components/document-link-display-modal/document-link-display-modal.component';
import { CollapsibleCardComponent } from './components/collapsible-card/collapsible-card.component';
import { DoNotTestComponent } from './components/do-not-test/do-not-test.component';
import { EnvironmentIndicatorComponent } from './components/environment-indicator/environment-indicator.component';
import { ImpersonationIndicatorComponent } from './components/impersonation-indicator/impersonation-indicator.component';
import { PageDividerComponent } from './components/page-divider/page-divider.component';
import { PushNotificationIndicatorComponent } from './components/push-notification-indicator/push-notification-indicator.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { VersionUpdateModalComponent } from './components/version-update-modal/version-update-modal.component';
import { PreventSpaceAndLineBreakDirective } from './directives/prevent-space-and-line-break.directive';
import { SanitizeSpaceAndLineBreakDirective } from './directives/sanitize-space-and-line-break.directive';
import { EmptyComponent } from './empty/empty.component';
import { FilterDisplayItemComponent } from './components/filter-display-item/filter-display-item.component';
import { HalfStepDirective } from './directives/one-decimal.directive';

const defaultModules = [CommonModule, FormsModule, ReactiveFormsModule];

const customModules = [
    ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        timeOut: 3000, // Auto-close in 3s,
        autoDismiss: true,
        closeButton: true,
        countDuplicates: true,
        preventDuplicates: true,
    }),
    NgSelectModule,
    TranslocoModule,
    NgPipesModule
];


const customComponents = [
    DocumentLinkDisplayModalComponent,
    EmptyComponent,
    UnderConstructionComponent,
    ImpersonationIndicatorComponent,
    EnvironmentIndicatorComponent,
    PushNotificationIndicatorComponent,
    PageDividerComponent,
    AssignmentListComponent,
    AssignmentSchedulesListComponent,
    FilterDisplayItemComponent,
    SponsorsComponent,
    CollapsibleCardComponent,
    DoNotTestComponent,
    VersionUpdateModalComponent,
    SpinnerComponent
];

const pmtModules = [
    PmtDatepickerModule,
    PmtEssentialsModule,
    PmtBootstrapModule.forRoot({
        pmtActionModalConfig: {
            modalHeaderClass: 'bg-white',
            modalFooterClass: 'bg-white',
            modalBodyClass: 'bg-white',
            modalTitleClass: 'h4',
            buttonCancelClass: 'btn btn-light',
            buttonSubmitClass: 'btn btn-primary'
        }
    }),
    PmtPushNotificationsModule
];

const customDirectives = [
    PreventSpaceAndLineBreakDirective,
    SanitizeSpaceAndLineBreakDirective,
    HalfStepDirective
];

@NgModule({
    imports: [
        defaultModules,
        customModules,
        pmtModules,
        RouterModule,
    ],
    declarations: [
        customComponents,
        customDirectives
    ],
    exports: [
        defaultModules,
        customModules,
        pmtModules,
        customComponents,
        customDirectives,
        ReactiveFormsModule,
        TooltipModule,
        TabsModule,
        BsDropdownModule
    ],
    providers: [DatePipe, BsModalService],
})
export class SharedModule { }
